import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { createHttpParamsFromObject } from '@libs/src/http-params/http-params.helper';
import { ReportingDataResponse } from '@main-client/src/app/group-data-view-beta/group-data-view.helper';

const REPORTING_URL = '/api/v3/reporting';

@Injectable({ providedIn: 'root' })
export class ReportingBackend {
  constructor(private readonly http: HttpClient) {}

  getMemberRoles(params: { groupId: string }) {
    return this.http.get(`${REPORTING_URL}/users/roles`, {
      params,
    });
  }

  getProfileCompletion(params: { groupId: string }) {
    return this.http.get(`${REPORTING_URL}/users/profile-completion`, {
      params,
    });
  }

  getUsersJoinedDate({
    endDate,
    groupId,
    startDate,
  }: {
    endDate: Date;
    groupId: string;
    startDate: Date;
  }) {
    const params = createHttpParamsFromObject({
      groupId,
      endDate: endDate.toISOString(),
      startDate: startDate.toISOString(),
    });
    return this.http.get<ReportingDataResponse>(
      `${REPORTING_URL}/users/joined-date`,
      {
        params,
      },
    );
  }
}
